import { createRouter, createWebHistory } from 'vue-router';
import { logout, getUser, refreshToken } from "@/services/authService"; 
import { useUserStore } from '@/stores/userStore'
// Auth
import LoginScreen from '../views/login/LoginScreen.vue';
import RegisterScreen from '../views/login/RegisterScreen.vue';
import ResetPassword from '../views/login/ResetPassword.vue';

// Eventos
import EventosList from '../views/events/EventosList.vue';
import DetalhesEventos from '../views/events/DetalhesEventos.vue';
import EventoAdversosView from '@/views/eventosadversos/EventoAdversosUsuario.vue';
import EventosAdversos from '@/views/eventosadversos/EventosAdversos.vue';
// Visões gerais
import MetricsView from '../views/assets/MetricsView.vue';
import NotFound from '../views/templates/NotFound.vue';
import Offline from '../views/templates/OfflineScreen.vue';

// Dashboards
import DashboardEquipamentos from '../views/dashboard/DashboardEquipamentos.vue';
import DashboardInstancias from '../views/instances/DashboardInstancias.vue';
import DashboardUnidades from '../views/servers/DashboardUnidades.vue';

// Pendências
import PendenciasDirecao from '../views/pending/PendenciasList.vue';
import PendenciaDetalhes from '../views/pending/PendenciaDetalhes.vue';
import PendenciasKanban from '../views/pending/PendenciasKanban.vue';
import InsightsPendencias from '../views/pending/InsightsPendencias.vue';
import UnidadesMedicasDetalhes from '../views/pending/UnidadesMedicasDetalhes.vue';

// Configurações
import CadastroFornecedores from '../views/settings/CadastroFornecedores.vue';
import CadastroCoordenadores from '../views/settings/CadastroCoordenadores.vue';
import ConfigScreen from '../views/settings/ConfigScreen.vue';
import GestaoUsuarios from '../views/settings/GestaoUsuarios.vue';
import GestaoAcessos from '../views/settings/GestaoAcessos.vue';
import GestaoGrupos from '../views/settings/GestaoGrupos.vue';
import GestaoEquipments from '../views/settings/GestaoEquipments.vue';
import GestaoClinicasSetores from '../views/settings/GestaoClinicasSetores.vue';
import GestaoInformes from '../views/settings/GestaoInformes.vue';
import MeuPerfil from '../views/settings/MeuPerfil.vue';
import GestaoFolgas from '../views/settings/GestaoFolgas';
import CalendarioFolgas from '../views/settings/CalendarioFolgas.vue';
import GestaoLocais from '../views/settings/GestaoLocais.vue';
import GestaoPreparos from '../views/settings/GestaoPreparos.vue';
import LogsPortal from '../views/settings/LogsPortal.vue';

// Outros
import ServerDetails from '@/views/guardian/ServerDetails.vue';
import IndicatorsView from '@/views/indicators/IndicatorsView.vue';
import DiversosView from '@/views/diversos/DiversosView.vue';
import AtivosList from '../views/assets/AtivosList.vue';
import KitsDetalhes from '../views/assets/KitsDetalhes.vue';
import TicketDetailView from '../views/help/TicketDetailView.vue';
import GerarToken from '../views/assets/GerarToken.vue';
import GestaoChamados from '../views/help/HelpScreen.vue';
import HomePage from '../views/home/HomePage.vue';
import FeedPage from '../views/feed/FeedPage.vue';
import VersionPage from '../views/templates/VersionPage.vue';
import NovidadesPage from '../views/changelog/NovidadesPage.vue';
import PrestacaoContasPage from '../views/prestacao/PrestacaoContasPage.vue';
import LancamentoNovidades from '../views/settings/LancamentoNovidades.vue';
import DocumentPage from '../views/documents/DocumentPage.vue';
import NotificationPage from '../views/notifications/NotificationPage.vue';
import AuditView from '../views/settings/AuditView.vue';
import TicketsView from '@/views/tickets/TicketsView.vue';
import MeetPage from '@/views/meet/MeetPage.vue';
import ModuloJuridico from '../views/juridico/ModuloJuridico.vue';


const routes = [
  {
    path: "/",
    name: "",
    component: LoginScreen,
    meta: { title: "Login - Dashboard" },
  },
  {
    path: "/login",
    name: "Login",
    component: LoginScreen,
    meta: { title: "Login - Dashboard" },
  },
  {
    path: "/notifications",
    name: "Notificações",
    component: NotificationPage,
    meta: { title: "Notificação - Dashboard" },
  },
  {
    path: "/checkin",
    name: "CheckIn",
    component: MeetPage,
    meta: { title: "Check-In - Dashboard", requiresAuth: true, roles: ["superadmin", "ti", "checkin", "admin", "direcao"] },

    
  },
  {
    path: "/formularioadversos",
    name: "EventoAdversosView",
    component: EventoAdversosView,
    meta: { title: "Eventos Adversos" },
  
},
  {
    path: "/eventosadversos",
    name: "EventoAdversos",
    component: EventosAdversos,
    meta: { title: "Eventos Adversos", requiresAuth: true },
  
},

  {
    path: "/register",
    name: "Register",
    component: RegisterScreen,
    meta: { title: "Cadastro - Dashboard" },
  },
  {
    path: "/reset-password",
    name: "ResetPassword",
    component: ResetPassword,
    meta: { title: "Recuperar Senha - Dashboard" },
  },
  {
    path: "/version",
    name: "VersionPage",
    component: VersionPage,
    meta: { title: "Versão do Software" },
  },
  {
    path: "/novidades",
    name: "NovidadesPage",
    component: NovidadesPage,
    meta: { title: "Novidades", requiresAuth: true },
  },

  {
    path: "/prestacao-contas",
    name: "PrestacaoContas",
    component: PrestacaoContasPage,
    meta: { title: "Prestação de Contas", requiresAuth: true, appKey: "prestacao-contas" },
  },

  {
    path: "/auditoria",
    name: "AuditView",
    component: AuditView,
    meta: { title: "Auditoria", requiresAuth: true, roles: ["superadmin", "auditoria"] },
  },

  {
    path: "/meuperfil",
    name: "MeuPerfil",
    component: MeuPerfil,
    meta: { title: "Meu Perfil",
      requiresAuth: true,
     },
  },
  {
    path: "/gerar_token",
    name: "GerarToken",
    component: GerarToken,
    meta: { title: "Gerar Token" },
  },
  {
    path: "/eventos",
    name: "EventosList",
    component: EventosList,
    meta: {
      requiresAuth: true,
      roles: ["engenhariaclinica", "direcao", "superadmin"],
      title: "Eventos - Dashboard",
    },
  },
  {
    path: "/eventos/:id",
    name: "DetalhesEvento",
    component: DetalhesEventos,
    meta: { requiresAuth: true, title: "Detalhes do Evento - Dashboard" },
    props: true,
  },
  {
    path: "/home",
    name: "HomePage",
    component: HomePage,
    meta: { requiresAuth: true, title: "Tela de Início" },
    props: true,
  },
  {
    path: "/dashboardequipamentos",
    name: "DashboardEquipamentos",
    component: DashboardEquipamentos,
    meta: { requiresAuth: true, title: "Equipamentos - Dashboard" },
  },
  {
    path: "/dashboardinstancias",
    name: "DashboardInstancias",
    component: DashboardInstancias,
    meta: {
      requiresAuth: true,
      roles: ["ti", "superadmin"],
      title: "Instâncias - Dashboard",
    },
  },
  {
    path: "/documents",
    name: "Documentos",
    component: DocumentPage,
    meta: {
      requiresAuth: true,
      roles: ["ti", "superadmin", "desenvolvedor"],
      title: "Documentos - Dashboard",
    },
  },
  {
    path: "/dashboardunidades",
    name: "DashboardUnidades",
    component: DashboardUnidades,
    meta: {
      requiresAuth: true,
      roles: ["ti", "superadmin"],
      title: "Unidades - Dashboard",
    },
  },
  {
    path: "/unidades/detalhes/:id",
    name: "UnidadesMedicasDetalhes",
    component: UnidadesMedicasDetalhes,
    meta: {
      requiresAuth: true,
      roles: ["ti", "superadmin", "engenhariaclinica"],
      title: "Unidades - Detalhes",
    },
    props: true,
  },
  {
    path: "/informes",
    name: "GestaoInformes",
    component: GestaoInformes,
    meta: {
      requiresAuth: true,
      roles: ["ti", "superadmin"],
      title: "Informes - Portal Paciente",
    },
  },
  {
    path: "/config/novidades",
    name: "LancamentoNovidades",
    component: LancamentoNovidades,
    meta: {
      requiresAuth: true,
      roles: ["superadmin"],
      title: "Lançar Novidades",
    },
  },
{
  path: "/help",
  name: "GestaoChamados",
  component: GestaoChamados,
  meta: {
    requiresAuth: true,
    title: "Portal de Ajuda",
  },
  
},


  {
    path: "/ativos",
    name: "Ativos",
    component: AtivosList,
    meta: {
      requiresAuth: true,
      roles: ["ti", "superadmin"],
      title: "Ativos - Dashboard",
    },
  },
    {
    path: "/ativos",
    name: "Ativos",
    component: AtivosList,
    meta: {
      requiresAuth: true,
      roles: ["ti", "superadmin"],
      title: "Ativos - Dashboard",
    },
  },
  {
    path: "/pendencias",
    name: "PendenciasDirecao",
    component: PendenciasDirecao,
    meta: {
      requiresAuth: true,
      roles: ["direcao", "superadmin", "coordenacao"],
      title: "Pendências - Dashboard",
    },
  },
  {
    path: "/pendencias/visualizer",
    name: "PendenciasKanban",
    component: PendenciasKanban,
    meta: {
      requiresAuth: true,
      roles: ["direcao", "superadmin", "coordenacao"],
      title: "Kanban - Pendências",
    },
  },
  {
    path: "/insights",
    name: "InsightsKanban",
    component: InsightsPendencias,
    meta: {
      requiresAuth: true,
      roles: ["direcao", "superadmin", "coordenacao"],
      title: "Kanban - Pendências",
    },
  },
  {
    path: "/metrics/:id",
    name: "Metrics",
    component: MetricsView,
    meta: {
      requiresAuth: true,
      roles: ["ti", "superadmin"],
      title: "Métricas - Dashboard",
    },
    props: true,
  },
  {
    path: "/kits/:id",
    name: "KitsDetalhes",
    component: KitsDetalhes,
    meta: {
      
      title: "Detalhes do Kit - Dashboard",
    },
    props: true,
  },
  {
    path: "/tickets/:id",
    name: "TicketsDetalhes",
    component: TicketDetailView,
    meta: {
      
      title: "Detalhes dos Tickets",
    },
    props: true,
  },
  {
    path: "/feed",
    name: "Feed",
    component: FeedPage,
    meta: {
      requiresAuth: true,
      permissionCheck: "feed_visualizar",
      title: "Feed Noticias",
    },
    props: true,
  },
  {
    path: "/feed/grupo/:groupId/post/:postId/",
    name: "FeedPostGrupo",
    component: FeedPage,
    meta: {
      requiresAuth: true,
      permissionCheck: "feed_visualizar",
      title: "Feed Noticias",
    },
    props: true,
  },
  {
    path: "/feed/post/:postId/",
    name: "FeedPost",
    component: FeedPage,
    meta: {
      requiresAuth: true,
      permissionCheck: "feed_visualizar",
      title: "Feed Noticias",
    },
    props: true,
  },
  {
    path: "/guardian",
    name: "Guardian",
    component: ServerDetails,
    meta: {
      requiresAuth: true,
      roles: ["ti", "superadmin", "desenvolvedor", "kiosk" ],
      title: "Guardian",
    },
    props: true,
  },
  {
    path: "/indicadores",
    name: "Indicators",
    component: IndicatorsView,
    meta: {
      requiresAuth: true,
      roles: ["ti", "superadmin", "indicadores"],
      title: "Indicadores",
    },
    props: true,
  },
  {
    path: "/diversos",
    name: "Diversos",
    component: DiversosView,
    meta: {
      requiresAuth: true,
      appKey: "diversos",
      title: "SQLs Diversos",
    },
    props: true,
  },
  {
    path: "/tickets",
    name: "Tickets",
    component: TicketsView,
    meta: {
      requiresAuth: true,
      title: "Chamados",
    },
    props: true,
  },
  {
    path: "/pendencia/detalhes/:id",
    name: "PendenciaDetalhes",
    component: PendenciaDetalhes,
    meta: {
      requiresAuth: true,
      roles: ["direcao", "superadmin", "coordenacao"],
      title: "Detalhes da Pendência - Dashboard",
    },
    props: true,
  },
  {
    path: "/AtivosDetalhes/:id",
    name: "AtivosDetalhes",
    component: () => import('@/views/assets/AtivosDetalhes.vue'),
    meta: {
      requiresAuth: true,
      roles: ["ti", "superadmin"],
      title: "Ativos Detalhes",
    },
    props: true,
},
  {
    path: "/offline",
    name: "Offline",
    component: Offline,
    meta: { title: "Offline - Dashboard" },
  },
  {
    path: "/:pathMatch(.*)*",
    name: "NotFound",
    component: NotFound,
    meta: { title: "Página Não Encontrada - Dashboard" },
  },
  {
    path: "/config/fornecedores",
    name: "CadastroFornecedores",
    component: CadastroFornecedores,
    meta: {
      requiresAuth: true,
      roles: ["direcao", "superadmin"],
      title: "Fornecedores - Dashboard",
    },
  },
  {
    path: "/config/coordenadores",
    name: "CadastroCoordenadores",
    component: CadastroCoordenadores,
    meta: {
      requiresAuth: true,
      roles: ["direcao", "superadmin"],
      title: "Coordenadores - Dashboard",
    },
  },
  {
    path: "/config/users",
    name: "GestaoUsuarios",
    component: GestaoUsuarios,
    meta: {
      requiresAuth: true,
      roles: ["direcao", "superadmin"],
      title: "Gestao Usuarios - Dashboard",
    },
  },
   {
    path: "/manager/daysoff",
    name: "GestaoFolgas",
    component: GestaoFolgas,
    meta: {
      requiresAuth: true,
      roles: ["direcao", "superadmin", "ti", "TI"],
      title: "Gestao Usuarios - Dashboard",
    },
  },
  {
    path: "/config/groups",
    name: "GestaoAcessos",
    component: GestaoAcessos,
    meta: {
      requiresAuth: true,
      roles: ["direcao", "superadmin"],
      title: "Gestao Acessos - Dashboard",
    },
  },
  {
    path: "/config/grupos",
    name: "GestaoGrupos",
    component: GestaoGrupos,
    meta: {
      requiresAuth: true,
      roles: ["superadmin"],
      title: "Gestao Grupos - Dashboard",
    },
  },
  {
    path: "/config/equipments",
    name: "GestaoEquipments",
    component: GestaoEquipments,
    meta: {
      requiresAuth: true,
      roles: ["direcao", "superadmin", "engenhariaclinica"],
      title: "Gestao de Equipamentos - Dashboard",
    },
  },
  {
    path: "/config/locais",
    name: "GestaoLocais",
    component: GestaoLocais,
    meta: { title: "Gestão de Locais", requiresAuth: true, roles: ["superadmin"] },
  },
  {
    path: "/config/preparos",
    name: "GestaoPreparos",
    component: GestaoPreparos,
    meta: { title: "Gestão de Preparos", requiresAuth: true, roles: ["superadmin", "preparos"] },
  },
  {
    path: "/config/logs-portal",
    name: "LogsPortal",
    component: LogsPortal,
    meta: { title: "Logs do Portal", requiresAuth: true, roles: ["superadmin", "desenvolvedor"] },
  },
  {
    path: "/config/preferences",
    name: "GestaoClinicasSetores",
    component: GestaoClinicasSetores,
    meta: {
      requiresAuth: true,
      roles: ["direcao", "superadmin"],
      title: "Cadastro de Clinicas e Setores - Dashboard",
    },
  },
  {
    path: "/config",
    name: "ConfigScreen",
    component: ConfigScreen,
    meta: {
      requiresAuth: true,
      roles: ["direcao", "superadmin", "ti", "engenhariaclinica"],
      title: "Configurações - Dashboard",
    },
  },
  {
    path: "/calendario-folgas",
    name: "CalendarioFolgasFull",
    component: CalendarioFolgas,
    meta: { title: "Calendário de Folgas" }
  },
  {
    path: "/modulo-juridico",
    name: "ModuloJuridico",
    component: ModuloJuridico,
    meta: {
    requiresAuth: true,
    roles: ["juridico", "juridico_admin", "superadmin"],
    title: "Módulo Jurídico - Dashboard",
    },
  },
  {
    path: "/juridico",
    name: "Juridico",
    component: ModuloJuridico,
    meta: {
    requiresAuth: true,
    roles: ["juridico", "juridico_admin", "superadmin"],
    title: "Módulo Jurídico - Dashboard",
    },
  },
];



// Criação do roteador
const router = createRouter({
  history: createWebHistory(),
  routes,
});

const resolveAppSlugFromFrontRoute = (path) => {
  const normalized = String(path || "").toLowerCase();
  if (normalized.startsWith("/modulo-juridico") || normalized.startsWith("/juridico")) return "juridico";
  if (normalized.startsWith("/feed")) return "feed";
  if (normalized.startsWith("/eventosadversos")) return "eventos-adversos";
  if (normalized.startsWith("/guardian")) return "guardian";
  if (normalized.startsWith("/indicadores")) return "indicadores";
  if (normalized.startsWith("/diversos")) return "diversos";
  if (normalized.startsWith("/manager/daysoff")) return "daysoff";
  if (normalized.startsWith("/notifications")) return "notifications";
  if (normalized.startsWith("/novidades")) return "changelog";
  if (normalized.startsWith("/prestacao-contas")) return "prestacao-contas";
  return null;
};

// Revalida a sessão no backend no máximo a cada 5 minutos. Entre navegações a sessão
// já carregada no store é suficiente; um 401 em qualquer chamada é tratado pelo
// interceptor do apiClient (refresh + retry, ou logout).
const SESSION_REVALIDATE_MS = 5 * 60 * 1000;

const sessaoDoStore = (userStore) => {
  if (!userStore.autenticado) return null;
  if (!Object.keys(userStore.appPermissions || {}).length) return null;
  if (Date.now() - (userStore.permissoesAtualizadasEm || 0) > SESSION_REVALIDATE_MS) return null;
  return {
    groups: userStore.grupos || [],
    app_permissions: userStore.appPermissions || {},
    feed_permissions: userStore.feedPermissions,
    eventos_adversos_permissions: userStore.eventosAdversosPermissions,
  };
};

router.beforeEach(async (to, from, next) => {
  try {
    // Atualiza o título da página dinamicamente
    document.title = to.meta.title || "Dashboard";

    // Verifica conexão offline
    if (!navigator.onLine) {
      if (to.name !== "Offline") {
        return next({
          name: "Offline",
          query: { redirect: to.fullPath },
        });
      }
    } else if (to.name === "Offline") {
      const redirect = to.query.redirect || "/";
      return next(redirect);
    }

    // Verifica se a rota exige autenticação
    const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);
    if (!requiresAuth) return next();

    // Verifica se o usuário está autenticado (store primeiro; backend só quando necessário)
    const userStore = useUserStore();
    let user = sessaoDoStore(userStore);
    if (!user) {
      user = await getUser();
      if (!user) {
        // Tenta refresh se não autenticado
        const refreshed = await refreshToken();
        if (refreshed) {
          user = await getUser();
        }
      }
    }

    if (!user) {
      await logout(); // Limpa sessão, tokens, etc.
      return next({ name: "Login", query: { accessDenied: true } });
    }

    // Captura os grupos do usuário via Pinia:
    const userGroups = userStore.grupos || []; // Certifique-se que a propriedade "groups" exista no seu store
    const appSlug = to.meta.appKey || resolveAppSlugFromFrontRoute(to.path);
    const appPermissions = user?.app_permissions || userStore.appPermissions || {};

    if (appSlug && !appPermissions[appSlug]) {
      return next({
        name: "DashboardEquipamentos",
        query: { unauthorized: true },
      });
    }

    if (to.meta.permissionCheck === "feed_visualizar") {
      const podeVisualizar = !!user?.feed_permissions?.pode_visualizar_feed;
      if (!podeVisualizar) {
        return next({
          name: "DashboardEquipamentos",
          query: { unauthorized: true },
        });
      }
    }

    // Verifica permissões por grupo (roles)
    const allowedRoles = to.meta.roles || [];
    if (
      allowedRoles.length > 0 &&
      !allowedRoles.some(role => userGroups.includes(role))
    ) {
      return next({
        name: "DashboardEquipamentos", // ou uma rota "403"
        query: { unauthorized: true },
      });
    }

    next(); // Tudo certo, permite navegação

  } catch (error) {
    console.error("Erro no middleware de rota:", error);
    await logout(); // Por segurança
    return next({ name: "Login", query: { error: true } });
  }
});






export default router;
